/* ===================================================================
   TSV Page Transitions & Micro-interactions
   The Scent Vault — premium feel layer

   1. Page fade-out on navigation (with subtle scale)
   2. IntersectionObserver for scroll-triggered card reveals
   3. Accord chip stagger animation triggers
   4. Filter pill entrance animation
   5. Add-to-Cart checkmark feedback
   6. Skeleton loading for Load More
   =================================================================== */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ===========================================
     1. PAGE FADE-OUT ON LINK CLICK
     =========================================== */
  var tsvNavigating = false;

  document.addEventListener('click', function (e) {
    if (tsvNavigating) return;

    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    if (href.startsWith('#') || href.startsWith('javascript') || href.startsWith('mailto') || href.startsWith('tel')) return;
    if (link.target === '_blank') return;
    if (e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (link.hasAttribute('download')) return;
    if (link.closest('.cart-drawer, .quick-add, .shopify-payment-button, cart-drawer, cart-notification, .header__submenu, .mega-menu, details')) return;

    e.preventDefault();
    tsvNavigating = true;

    var main = document.querySelector('#MainContent');
    var topbar = document.querySelector('.title-topbar');

    /* Fade-out with subtle scale */
    if (main) {
      main.style.transition = 'opacity 0.3s ease-in, transform 0.35s ease-in';
      main.style.opacity = '0';
      main.style.transform = 'translateY(-24px) scale(0.985)';
    }
    if (topbar) {
      topbar.style.transition = 'opacity 0.25s ease-in';
      topbar.style.opacity = '0';
    }

    /* Create warm white flash overlay */
    var flash = document.createElement('div');
    flash.className = 'tsv-flash-overlay';
    document.body.appendChild(flash);

    /* Trigger fade-in of overlay after a frame */
    requestAnimationFrame(function () {
      flash.classList.add('is-active');
    });

    setTimeout(function () {
      window.location.href = href;
    }, 380);

    // Safety reset — if navigation doesn't happen (e.g. beforeunload cancelled)
    setTimeout(function () { tsvNavigating = false; }, 3000);
  });

  /* ===========================================
     2. SCROLL-TRIGGERED CARD FADE-UP
     =========================================== */
  function initScrollReveal() {
    var targets = document.querySelectorAll(
      '#product-grid .grid__item,' +
      '.product-grid .grid__item,' +
      '.collection-product-list .grid__item,' +
      '.tsv-coll-tabs .grid__item'
    );

    targets.forEach(function (el) {
      if (el.classList.contains('tsv-reveal')) return;
      el.classList.add('tsv-reveal');
    });

    var gridItems = document.querySelectorAll('.tsv-reveal:not(.tsv-visible)');
    var lastTop = -1;
    var colIndex = 0;

    gridItems.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (Math.abs(rect.top - lastTop) > 20) {
        colIndex = 0;
        lastTop = rect.top;
      }
      el.style.setProperty('--tsv-delay', (colIndex * 0.08) + 's');
      colIndex++;
    });

    if (!window._tsvRevealObserver) {
      window._tsvRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tsv-visible');
            window._tsvRevealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
      });
    }

    document.querySelectorAll('.tsv-reveal:not(.tsv-visible)').forEach(function (el) {
      window._tsvRevealObserver.observe(el);
    });
  }

  /* ===========================================
     3. ACCORD CHIP STAGGER
     =========================================== */
  function tagAccordChips() {
    document.querySelectorAll('.tsv-accord-row .tsv-chip, .tsv-scent-snapshot .tsv-chip').forEach(function (chip) {
      if (!chip.classList.contains('tsv-accord-chip')) {
        chip.classList.add('tsv-accord-chip');
      }
    });
  }

  /* ===========================================
     4. FILTER PILL ENTRANCE
     =========================================== */
  function initPillEntrance() {
    var pills = document.querySelectorAll(
      '.facets__disclosure > summary,' +
      'summary.facets__summary'
    );

    pills.forEach(function (pill, i) {
      if (pill.classList.contains('tsv-pill-enter')) return;
      pill.classList.add('tsv-pill-enter');
      pill.style.transitionDelay = (i * 0.06) + 's';
    });

    if (!window._tsvPillObserver) {
      window._tsvPillObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var container = entry.target.closest('.facets-container, #main-collection-filters, .facets__wrapper');
            if (container) {
              container.querySelectorAll('.tsv-pill-enter').forEach(function (p) {
                p.classList.add('tsv-visible');
              });
            }
            entry.target.classList.add('tsv-visible');
            window._tsvPillObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
    }

    document.querySelectorAll('.tsv-pill-enter:not(.tsv-visible)').forEach(function (el) {
      window._tsvPillObserver.observe(el);
    });
  }

  /* ===========================================
     5. ADD-TO-CART CHECKMARK FEEDBACK
     =========================================== */
  function initCartFeedback() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(
        'button[type="submit"][name="add"],' +
        '.product-form__submit,' +
        'button.quick-add__submit'
      );
      if (!btn) return;
      if (btn.closest('.shopify-payment-button')) return;

      btn.classList.add('tsv-cart-added');
      btn.addEventListener('animationend', function () {
        btn.classList.remove('tsv-cart-added');
      }, { once: true });

      setTimeout(function () {
        showCartCheck();
      }, 400);
    });
  }

  function showCartCheck() {
    var check = document.createElement('div');
    check.className = 'tsv-cart-check';
    check.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="4 12 10 18 20 6"></polyline></svg>';
    document.body.appendChild(check);

    setTimeout(function () {
      check.style.transition = 'opacity 0.3s ease';
      check.style.opacity = '0';
      setTimeout(function () { check.remove(); }, 350);
    }, 1200);
  }

  /* ===========================================
     6. SKELETON LOADING FOR LOAD MORE
     =========================================== */
  function initSkeletonLoading() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.tsv-loadmore-btn');
      if (!btn) return;

      var grid = document.querySelector('#product-grid') || document.querySelector('.product-grid');
      if (!grid) return;

      var skeletonWrap = document.createElement('div');
      skeletonWrap.className = 'tsv-skeleton-row';
      skeletonWrap.style.cssText = 'display:grid;grid-template-columns:repeat(4,1fr);gap:20px;padding:20px 0;';

      for (var i = 0; i < 4; i++) {
        var skel = document.createElement('div');
        skel.className = 'tsv-skeleton tsv-skeleton-card';
        skeletonWrap.appendChild(skel);
      }
      grid.appendChild(skeletonWrap);

      var obs = new MutationObserver(function () {
        var newCards = grid.querySelectorAll('.grid__item:not(.tsv-reveal)');
        if (newCards.length > 0) {
          skeletonWrap.remove();
          obs.disconnect();
          setTimeout(initScrollReveal, 50);
        }
      });
      obs.observe(grid, { childList: true, subtree: true });

      setTimeout(function () {
        if (skeletonWrap.parentNode) {
          skeletonWrap.remove();
          obs.disconnect();
        }
      }, 5000);
    });
  }

  /* ===========================================
     7. PAGE LOAD FADE-IN
     =========================================== */
  function initPageFadeIn() {
    /* Fade out the white flash overlay from previous page */
    var flash = document.querySelector('.tsv-flash-overlay');
    if (!flash) {
      flash = document.createElement('div');
      flash.className = 'tsv-flash-overlay is-active';
      document.body.appendChild(flash);
    }

    requestAnimationFrame(function () {
      flash.classList.remove('is-active');
      flash.classList.add('is-fading');
    });

    setTimeout(function () {
      if (flash.parentNode) flash.remove();
    }, 500);

    var main = document.querySelector('#MainContent');
    if (main) {
      main.style.transition = '';
      main.style.opacity = '';
      main.style.transform = '';
      main.classList.add('tsv-page-enter');
    }
    var topbar = document.querySelector('.title-topbar');
    if (topbar) {
      topbar.style.transition = '';
      topbar.style.opacity = '';
      topbar.classList.add('tsv-page-enter');
    }
  }

  /* ===========================================
     8. BOUTIQUE BUTTON — CSS-OWNED HOVER (legacy cleanup)
     =========================================== */
  /* The previous version of this function attached mouseenter/mouseleave
     handlers that wrote inline !important styles for the boutique button —
     mouseenter set #ccb46a (dark gold) and mouseleave set #d9c18a (light gold)
     instead of clearing back to black. The inline !important beat every
     stylesheet rule, so the button appeared "stuck on gold" after the first
     hover, and cycled between two gold shades on subsequent hovers.

     The CSS in card-product.liquid already handles colours correctly:
       base   → black with white text
       :hover → gold (#d9c18a) with black text
       unhover snaps back to black via the cascade.

     So this function now just strips any legacy inline gold styles that
     previous deploys may have left on cached pages, and binds NO listeners.
     CSS owns this transition end-to-end. */
  function initBoutiqueHover() {
    var btns = document.querySelectorAll('.view-details-mobile-btn.view-details--boutique');
    btns.forEach(function (btn) {
      var s = btn.getAttribute('style') || '';
      if (!s) return;
      var cleaned = s
        .replace(/background(-color)?\s*:[^;]*!important\s*;?/gi, '')
        .replace(/border(-color)?\s*:[^;]*!important\s*;?/gi, '')
        .replace(/^\s*;+/, '')
        .trim();
      if (cleaned) {
        btn.setAttribute('style', cleaned);
      } else {
        btn.removeAttribute('style');
      }
    });
  }

  /* ===========================================
     INIT
     =========================================== */
  function init() {
    initPageFadeIn();
    tagAccordChips();
    initScrollReveal();
    initPillEntrance();
    initCartFeedback();
    initSkeletonLoading();
    initBoutiqueHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });

})();